import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the bundle and promotion api
 */
export class UnitService extends BaseService {

	constructor() {	
		super();
	}
	
	async getUnitsForCustomer(paging, customerId) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/secure-fuel-units/search/'+ customerId + params);		
		return data;		
	}
	

	async saveUnit(unit, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/secure-fuel-units/customers/' + unit.carrierId + '/units/' + unit.unitId, unit);
		} else {
			saved = await this.makePOSTRequest('/api/resource/secure-fuel-units', unit);
		}
		return saved;		
	}	
	
	async deleteUnit(customerId, unitId) {
		var data = await this.makeDELETERequest('/api/resource/secure-fuel-units/customers/' + customerId + '/units/' + unitId);		
		return data;		
	}
	
	async deleteUnits(customerId, multipleIds) {
		var data = await this.makeDELETERequest('/api/resource/secure-fuel-units/customers/' + customerId + '/units', multipleIds);		
		return data;		
	}	
	
	downloadUnits(customerId, options) {		
		var params = '';
		if (options) {
			params = '?' + this.toQueryParam(options);
		}
		this.downloadFile('/api/resource/secure-fuel-units/export/' + customerId + params, true);		
	};		
	
}